// react
import React from "react";
import ReactDOM from "react-dom";

// Compiled LESS Theme imports
import './assets/css/fonts.css';
import './assets/css/icons/icomoon/styles.css';
import './assets/css/bootstrap.min.css';
import './assets/css/core.min.css';
import './assets/css/components.min.css';
import './assets/css/colors.min.css';
import './assets/css/hamburgers.css';
import './assets/css/animations.css';

// Components
import App from "./App";
import "./Views/Login/login.css";

// React Router
import { BrowserRouter } from 'react-router-dom';

// jQuery and Bootstrap
global.jQuery = require('jquery');
require('bootstrap');

/**********************************************************
 * 
 *  Index is responsible for mounting the app to the dom
 *  and importing above the fold resources
 * 
 **********************************************************/

ReactDOM.render(

  <BrowserRouter basename='/'>
    <App/>
  </BrowserRouter>,

  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js